module.exports = __webpack_public_path__ + "img/fajfjka_zelena.2ee2eff6.svg";